import Dark from './Dark';
import './Themes.css'
import React from 'react'
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';




function Theme({onChange , show,  onClose }) {
  const { ref, inView } = useInView({
    threshold: 0.3, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const topVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1  } }
  };

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView]);



 

  


  if (!show) {
    return null;
  }

  function handleContainerClick(e) {
    if (e.target.classList.contains('customize-theme')) {
      onClose();
    }
  } 

 
  

  return (
 
    <motion.div   ref={ref} variants={topVariants} 
    initial="hidden"
    animate={animation}
    className="customize-theme"  
    onClick={handleContainerClick} >
      <div className="card">
        <h2>Customize your view</h2>
        <p className='text-muted'>Manage colour & background</p>
        <div className="color">
          <h4>Color</h4>
              <div className="choose-color" >
                 <span className="color-1"  onClick={() => onChange('#5928E5')} ></span>
                 <span className="color-2" onClick={() => onChange('#e5de00')} ></span>
                 <span className="color-3" onClick={() => onChange('#FF0000')} ></span>
                 <span className="color-4" onClick={() => onChange('#00FF00')} ></span>
                  <span className="color-5" onClick={() => onChange('#19BDFF')} ></span>
          </div>
        </div>
        <Dark/>
      </div>
    </motion.div>

  )
}


export default Theme






  


 


